var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 9.5C2.79086 9.5 0.999999 7.70914 1 5.5C1 3.29086 2.79086 1.5 5 1.5C7.20914 1.5 9 3.29086 9 5.5C9 7.70914 7.20914 9.5 5 9.5Z","stroke":"currentColor","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }